
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FormFeedback extends Vue {
    @Prop() error!: string;
}
